<div class="table-container m-t-12">
  @if ((apiCallStatus === 'COMPLETED_SUCCESFULLY' && data.length > 0) || apiCallStatus === 'IN_PROGRESS') {
    <mc-table
      data-cy="repair-code-exclusion-list"
      [data]="apiCallStatus === 'COMPLETED_SUCCESFULLY' && data.length > 0 ? data : mockDataForLoadingAnimation"
      fit="small"
      [columns]="columns"
      nowrap="true"
      sortmanual
      sortdefaultdirection="ascending"
      (sortchange)="onSortDirectionChange($event)"
      tabularFigures="true"
      headersticky
      height="100%">
      @for (row of data; track row; let i = $index) {
        <div slot="{{ row.id }}_repairMode">
          <button type="button" class="mode-link" (click)="onView(row)">
            {{ row.repairMode }}
          </button>
        </div>
        <div slot="{{ row.id }}_actions" class="action-icon">
          @if (authPolicy.canEditRepairCodeExclusion) {
            <mc-button
              padding="compact"
              fit="small"
              hiddenlabel
              icon="pencil"
              appearance="primary"
              variant="plain"
              slot="trigger"
              (click)="onEdit(row)"
              (keydown.enter)="onEdit(row)"
              (keydown.space)="$event.preventDefault(); onEdit(row)"></mc-button>
          }
          @if (authPolicy.canDeleteRepairCodeExclusion) {
            <mc-button
              padding="compact"
              fit="small"
              hiddenlabel
              icon="trash"
              appearance="primary"
              variant="plain"
              slot="trigger"
              (click)="onDelete(row)"
              (keydown.enter)="onDelete(row)"
              (keydown.space)="$event.preventDefault(); onDelete(row)"></mc-button>
          }
        </div>
      }
      @for (row of mockDataForLoadingAnimation; track $index) {
        @for (item of columns; track $index) {
          <div slot="{{ row.id }}_{{ item.id }}"><app-loader></app-loader></div>
        }
      }
    </mc-table>
  } @else {
    <div class="pure-g">
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-204 flex-container flex-center no-data">
        <span i18n>No Data Found</span>
      </div>
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
        <span i18n>To widen your search, change or remove filters.</span>
      </div>
      <div class="pure-u-md-24-24 pure-u-lg-24-24 pure-u-xl-24-24 m-t-36 flex-container flex-center">
        <mc-button
          i18n-label="Button"
          label="Clear all filters"
          variant="filled"
          appearance="primary"
          (click)="clearFilter()"
          (keydown.enter)="clearFilter()"
          (keydown.space)="clearFilter()"
          fit="small"></mc-button>
      </div>
    </div>
  }
</div>
@if (data.length > 0) {
  <app-pagination
    [currentPage]="currentPage"
    [lastPage]="lastPage"
    [totalRecords]="totalItemCount ?? 0"
    [pageLimit]="pageLimit"
    [showCountOnly]="true"
    (pageChange)="onPageChanged($event)"
    (pageSizeChange)="onPageLimitChanged($event)">
  </app-pagination>
}

<!-- Delete confirmation modal -->
<mc-modal fit="small" dimension="small" [open]="openDeleteConfirmation" (closed)="openDeleteConfirmation = false" heading="Delete Exclusion">
  <p>Are you sure you want to delete exclusion for repair code {{ selectedRow?.repairCode }} mode {{ selectedRow?.repairMode }}?</p>
  <mc-button
    slot="secondaryAction"
    appearance="neutral"
    variant="outlined"
    (click)="cancelDelete()"
    (keydown.enter)="cancelDelete()"
    (keydown.space)="$event.preventDefault(); cancelDelete()"
    >Cancel</mc-button
  >
  <mc-button
    slot="primaryAction"
    appearance="primary"
    (click)="confirmDelete()"
    (keydown.enter)="confirmDelete()"
    (keydown.space)="$event.preventDefault(); confirmDelete()"
    >Delete</mc-button
  >
</mc-modal>
